import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import SVG from 'react-inlinesvg';
import ImageWrapper from '../imageWrapper';
var InlineSVGRenderer = function (_a) {
    var svgSrc = _a.svgSrc, alt = _a.alt, className = _a.className, svgClassName = _a.svgClassName, svgStrokeColor = _a.svgStrokeColor, svgFillColor = _a.svgFillColor, svgDimensions = _a.svgDimensions;
    var mediaQuery = window.matchMedia('(max-width: 600px)');
    var isMobile = mediaQuery.matches;
    var height = (svgDimensions === null || svgDimensions === void 0 ? void 0 : svgDimensions.height) || '100%';
    var width = isMobile ? (svgDimensions === null || svgDimensions === void 0 ? void 0 : svgDimensions.mobileWidth) || '65px' : (svgDimensions === null || svgDimensions === void 0 ? void 0 : svgDimensions.width) || '65px';
    if (!isMobile && !(svgDimensions === null || svgDimensions === void 0 ? void 0 : svgDimensions.heightImportant)) {
        height = '100%';
    }
    return (_jsx(SVG, { src: svgSrc, cacheRequests: true, className: svgClassName, uniquifyIDs: true, preProcessor: function (code) {
            return code
                .replace(/height=".*?"/, "height=".concat(height))
                .replace(/width=".*?"/, "width=".concat(width))
                .replace(svgFillColor && /fill=".*?"/g, "fill=".concat(svgFillColor))
                .replace(svgStrokeColor && /stroke=".*?"/g, "stroke=".concat(svgStrokeColor));
        }, children: _jsx(ImageWrapper, { src: svgSrc, alt: alt, className: className }) }));
};
export default InlineSVGRenderer;
